const BankProcessor = {
  Brankas: "brankas",
  DragonPay: "dragonpay",
  BPI: "bpi",
};

export default BankProcessor;
